module.exports = __webpack_public_path__ + "static/media/video.10850792.svg";